/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateSponsoredRewardRequest,
    CreateSponsoredRewardRequestFromJSON,
    CreateSponsoredRewardRequestFromJSONTyped,
    CreateSponsoredRewardRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateSponsoredCompetitionBody
 */
export interface UpdateSponsoredCompetitionBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    sponsorBrandName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<CreateSponsoredRewardRequest>}
     * @memberof UpdateSponsoredCompetitionBody
     */
    rewards: Array<CreateSponsoredRewardRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSponsoredCompetitionBody
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSponsoredCompetitionBody
     */
    runningYear: number;
    /**
     * URL to the brand\'s website (to display on competition page)
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    brandUrl: string;
}

export function UpdateSponsoredCompetitionBodyFromJSON(json: any): UpdateSponsoredCompetitionBody {
    return UpdateSponsoredCompetitionBodyFromJSONTyped(json, false);
}

export function UpdateSponsoredCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSponsoredCompetitionBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'description': json['description'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(CreateSponsoredRewardRequestFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'brandUrl': json['brandUrl'],
    };
}

export function UpdateSponsoredCompetitionBodyToJSON(value?: UpdateSponsoredCompetitionBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sponsorBrandName': value.sponsorBrandName,
        'description': value.description,
        'promotionImage': value.promotionImage,
        'rewards': ((value.rewards as Array<any>).map(CreateSponsoredRewardRequestToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'brandUrl': value.brandUrl,
    };
}


